
import request from '../util/request'

  export function getAccountStaffDepartmentTree(data) {
    return request({
      url: 'admin/account/getStaffDepartmentTree',
      method: 'post',
      data:data
    })
  }

  export function saveAccountStaff(data) {
    return request({
      url: 'admin/account/saveStaff',
      method: 'post',
      data:data
    })
  }
  
  export function getAccountStaffList(data) {
    return request({
      url: 'admin/account/getStaffList',
      method: 'post',
      data:data
    })
  }
  
  export function deleteAccountStaff(data) {
    return request({
      url: 'admin/account/deleteStaff',
      method: 'post',
      data:data
    })
  }
  
  export function getAccountStaffData(data) {
    return request({
      url: 'admin/account/getStaffData',
      method: 'post',
      data:data
    })
  }
  
  export function getAccountStaffDetail(data) {
    return request({
      url: 'admin/account/getStaffDetail',
      method: 'post',
      data:data
    })
  }

  export function pauseAccountStaff(data) {
    return request({
      url: 'admin/account/pauseStaff',
      method: 'post',
      data:data
    })
  }
  
  export function eableAccountStaff(data) {
    return request({
      url: 'admin/account/eableStaff',
      method: 'post',
      data:data
    })
  }
  export function getStaff(data) {
    return request({
      url: 'admin/getStaff',
      method: 'post',
      data:data
    })
  }

  
  
  





























// WEBPACK FOOTER //
// ./src/api/staff.js